<div class="padding">
  <!-- Main container -->
  <!-- Panels are NOT gated on _loading: each child fetches its own data in ngOnInit,
       and gating them here delayed those requests until the forkJoin below resolved.
       The spinner overlay covers the page only until the orders and database
       overview data this component owns has loaded. -->
  <div>
    <div class="flex-container">
      <!-- Pending orders widget -->
      <div class="flex-item">
        <app-manual-orders [data]="this._manualOrders" [total]="this._totalManualOrders" [loading]="this._loading"></app-manual-orders>
      </div>
      <!-- End of pending orders widget-->
      <!-- Failed orders widget -->
      <div class="flex-item">
        <app-failed-orders [data]="this._failedOrders" [total]="this._totalFailedOrders" [loading]="this._loading"></app-failed-orders>
      </div>
      <!-- End of failed orders widget -->
    </div>
    <div class="flex-container">
      <!-- Database overviews widget -->
      <div class="flex-item">
        <app-database-overview [dataSource]="this._databaseOverviews" [loading]="this._loading"></app-database-overview>
      </div>
      <!-- End of database overviews Widget -->
    </div>
    <div class="flex-container">
      <!-- Envelopes overview widget -->
      <div class="flex-item">
        <app-envelopes></app-envelopes>
      </div>
      <!-- Envelopes overview Widget -->
    </div>
    <div class="flex-container">
      <!-- Batch summaries widget -->
      <div class="flex-item">
        <app-batch-summaries></app-batch-summaries>
      </div>
      <!-- End of batch summaries widget -->
    </div>
    <div class="flex-container">
      <!-- Automation monitors widget -->
      <div class="flex-item">
        <app-automation-monitors></app-automation-monitors>
      </div>
      <!-- End of automation monitors widget -->
    </div>
  </div>
  <!-- End of main container -->

  <!-- Spinner (overlays the panels until the shared dashboard requests have completed) -->
  @if (_loading) {
    <div class="loading-spinner-overlay">
      <mat-spinner></mat-spinner>
    </div>
  }
  <!-- End of spinner -->
</div>
